// Blog posts registry
// Add new blog posts here - they will automatically appear on the blog listing page

export const blogPosts = [
  {
    slug: 'accidental-landlord-guide-2026',
    title: 'The Accidental Landlord\'s Survival Guide: What To Do When You Can\'t Sell Your Home',
    excerpt: 'A record number of homeowners in 2026 are becoming landlords because the math stopped working on selling. Here\'s the 90-day survival guide for first-time accidental landlords — from legal disclosures to tenant screening to systems that keep it manageable.',
    author: 'NivasaPro Team',
    date: '2026-06-11',
    readTime: '9 min read',
    category: 'Best Practices',
    featured: false,
    gated: false,
    image: null,
    tags: ['Landlord Tips', 'Getting Started', 'Tenant Screening', 'Operations', 'First-Time Landlord']
  },
  {
    slug: 'rent-increase-strategy-keep-best-tenants',
    title: 'Rent Increase Strategy: How to Raise Rates Without Losing Your Best Tenants',
    excerpt: 'Raising rent is one of the most stressful moments in landlord-tenant relationships. Here\'s how to do it strategically — and keep the tenants worth keeping.',
    author: 'NivasaPro Team',
    date: '2026-06-11',
    readTime: '6 min read',
    category: 'Best Practices',
    featured: false,
    gated: true,
    image: null,
    tags: ['Rent Increases', 'Tenant Retention', 'Lease Renewals', 'Landlord Tips']
  },
  {
    slug: 'preventative-maintenance-competitive-advantage',
    title: 'Preventative Maintenance Is Your Biggest Competitive Advantage in 2026. Here\'s How to Use It.',
    excerpt: '56% of rental owners hire property managers specifically for maintenance help. 40% of uncertain tenants would renew if maintenance improved. Here\'s the three-layer system that turns your biggest headache into your sharpest differentiator.',
    author: 'NivasaPro Team',
    date: '2026-06-10',
    readTime: '8 min read',
    category: 'Operations',
    featured: false,
    gated: false,
    image: null,
    tags: ['Maintenance', 'Property Management', 'Tenant Retention', 'Competitive Strategy', 'Landlord Tips']
  },
  {
    slug: 'scale-without-hiring-2026',
    title: 'The Staffing Problem Every Growing Landlord Hits — And How to Get Past It',
    excerpt: 'Staffing constraints are the #1 barrier to scaling a rental portfolio in 2026. Here\'s how independent landlords are managing 20, 50, even 100 units without adding employees — using automation that pays for itself.',
    author: 'NivasaPro Team',
    date: '2026-06-06',
    readTime: '7 min read',
    category: 'Operations',
    featured: false,
    gated: false,
    image: null,
    tags: ['Automation', 'Landlord Tips', 'Property Management', 'Scaling', 'AI']
  },
  {
    slug: 'rental-fraud-ai-2026',
    title: 'AI-Generated Rental Fraud Is Surging. Here\'s How to Protect Your Properties.',
    excerpt: 'AI-generated document fraud jumped 500% in 2025. 93% of landlords have experienced rental fraud and 1 in 8 applications contains fake income docs. Here\'s the updated screening stack that actually works.',
    author: 'NivasaPro Team',
    date: '2026-06-05',
    readTime: '8 min read',
    category: 'Best Practices',
    featured: false,
    gated: false,
    image: null,
    tags: ['Tenant Screening', 'Fraud Prevention', 'Landlord Tips', 'AI']
  },
  {
    slug: 'ai-tenant-screening-2026',
    title: 'AI-Powered Tenant Screening in 2026: What Property Managers Are Actually Using',
    excerpt: 'One bad placement costs months of lost rent and legal headaches. In 2026, AI screening has gone from novelty to standard practice — but the quality gap between platforms is wide. Here\'s what\'s working.',
    author: 'NivasaPro Team',
    date: '2026-06-03',
    readTime: '7 min read',
    category: 'Technology',
    featured: false,
    gated: false,
    image: null,
    tags: ['Tenant Screening', 'AI', 'Landlord Tips', 'Automation']
  },
  {
    slug: 'tenant-turnover-cost-2026',
    title: 'Tenant Turnover Is the #1 Problem for Landlords in 2026 — Here\'s How to Fix It',
    excerpt: '42% of rental owners name tenant turnover their single biggest financial challenge. A single vacancy can cost $5,000–$6,000 before anything breaks. Here\'s the operational discipline that stops the bleeding.',
    author: 'NivasaPro Team',
    date: '2026-06-03',
    readTime: '7 min read',
    category: 'Best Practices',
    featured: false,
    gated: false,
    image: null,
    tags: ['Tenant Retention', 'Cash Flow', 'Landlord Tips', 'Operations']
  },
  {
    slug: 'fight-rising-insurance-costs',
    title: 'Insurance Costs Are Crushing Landlord Margins — Here\'s How to Fight Back',
    excerpt: 'Property insurance premiums have surged 75% in five years, averaging $2,412 annually by 2025. Here\'s how independent landlords are reclaiming margin without sacrificing coverage.',
    author: 'NivasaPro Team',
    date: '2026-06-02',
    readTime: '7 min read',
    category: 'Strategy',
    featured: false,
    gated: false,
    image: null,
    tags: ['Insurance', 'Cash Flow', 'Landlord Tips', 'Cost Savings']
  },
  {
    slug: 'late-rent-payments-2026',
    title: 'Late Rent Payments in 2026: Prevention, Collection, and Knowing When to Escalate',
    excerpt: 'Household budgets are tight and vacancy is rising. Here\'s the systematic approach to handling late rent — from screening to payment plans — that keeps good tenants and cuts legal exposure.',
    author: 'NivasaPro Team',
    date: '2026-06-02',
    readTime: '7 min read',
    category: 'Best Practices',
    featured: false,
    gated: false,
    image: null,
    tags: ['Tenant Relations', 'Cash Flow', 'Rent Collection', 'Landlord Tips']
  },
  {
    slug: 'lease-compliance-2026',
    title: 'The 2026 Lease Compliance Playbook: Safe Home Disclosures and What\'s Changed',
    excerpt: 'States are tightening tenant protection laws in 2026. If you\'re still using a 2024 lease template, you\'re already behind. Here\'s the annual audit checklist every independent landlord needs.',
    author: 'NivasaPro Team',
    date: '2026-06-02',
    readTime: '8 min read',
    category: 'Legal & Compliance',
    featured: false,
    gated: false,
    image: null,
    tags: ['Compliance', 'Lease', 'Regulations', 'Landlord Tips']
  },
  {
    slug: 'rental-operations-maturity-stages',
    title: 'From Reactive to Intelligent: The 5 Stages of Rental Operations Maturity',
    excerpt: 'Every landlord sits somewhere on a 5-tier maturity curve — from scrambling to put out fires every week to running a near-automated portfolio. Here\'s what each stage looks like, what keeps landlords stuck, and what it takes to move up.',
    author: 'NivasaPro Team',
    date: '2026-05-06',
    readTime: '7 min read',
    category: 'Strategy',
    featured: true,
    gated: false,
    image: null,
    tags: ['ROMI Score', 'Landlord Tips', 'Automation', 'Strategy']
  },
  {
    slug: 'pm-health-check',
    title: 'Where Does Your Rental Operation Stand? Get Your Free NivasaPro ROMI Score™',
    excerpt: 'The NivasaPro ROMI Score™ (Rental Operations Maturity Index) is a free 3-minute AI conversation that places your portfolio on a 5-tier maturity curve — and tells you exactly what to do next.',
    author: 'NivasaPro Team',
    date: '2026-05-05',
    readTime: '5 min read',
    category: 'Tools & Resources',
    featured: true,
    gated: false,
    image: null,
    tags: ['ROMI Score', 'Assessment', 'Landlord Tips', 'Automation']
  },
  {
    slug: 'what-is-agentic-ai-property-management',
    title: 'What is Agentic AI? The Future of Property Management',
    excerpt: 'Discover how agentic AI goes beyond simple automation to create truly intelligent property management systems that can think, decide, and act autonomously.',
    author: 'NivasaPro Team',
    date: '2026-02-10',
    readTime: '6 min read',
    category: 'Technology',
    featured: true,
    gated: true,
    image: null,
    tags: ['AI', 'Property Management', 'Technology', 'Automation']
  },
  {
    slug: 'landlord-guide-central-ohio-2026',
    title: 'The Central Ohio Landlord\'s Guide to 2026',
    excerpt: 'Key trends, regulations, and opportunities for rental property owners in Columbus and surrounding areas this year.',
    author: 'NivasaPro Team',
    date: '2026-01-22',
    readTime: '8 min read',
    category: 'Market Insights',
    featured: true,
    gated: true,
    image: null,
    tags: ['Central Ohio', 'Market Trends', 'Landlord Tips']
  },
  {
    slug: 'reduce-maintenance-costs-ai',
    title: '5 Ways AI Can Reduce Your Maintenance Costs',
    excerpt: 'Learn how predictive maintenance and smart automation can save landlords thousands of dollars annually on property upkeep.',
    author: 'NivasaPro Team',
    date: '2026-01-08',
    readTime: '5 min read',
    category: 'Tips & Tricks',
    featured: false,
    gated: true,
    image: null,
    tags: ['Maintenance', 'Cost Savings', 'AI', 'Tips']
  },
  {
    slug: 'tenant-communication-best-practices',
    title: 'Tenant Communication: From Frustration to Automation',
    excerpt: 'How modern landlords are using AI-powered communication to improve tenant satisfaction while reducing their own workload.',
    author: 'NivasaPro Team',
    date: '2025-12-28',
    readTime: '7 min read',
    category: 'Best Practices',
    featured: false,
    image: null,
    tags: ['Tenant Relations', 'Communication', 'Automation']
  }
];

// Helper function to get a post by slug
export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

// Helper function to get featured posts
export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

// Helper function to get posts by category
export const getPostsByCategory = (category) => {
  return blogPosts.filter(post => post.category === category);
};

// Helper function to get all unique categories
export const getCategories = () => {
  return [...new Set(blogPosts.map(post => post.category))];
};

// Helper function to get all unique tags
export const getTags = () => {
  const allTags = blogPosts.flatMap(post => post.tags);
  return [...new Set(allTags)];
};
